'use strict'

function RouteConfig ($urlRouterProvider, $stateProvider) {
  $urlRouterProvider.otherwise('/')

  $stateProvider.state('certificate-digital', {
    url: '/',
    templateUrl: 'app/modules/main/views/index.html'
  })

  $stateProvider.state('success', {
    url: '/success',
    templateUrl: 'app/modules/main/views/index.html'
  })
}

angular.module('app').config(RouteConfig)



//////////////////
// WEBPACK FOOTER
// ./configs/appRoutes.config.js
// module id = 86
// module chunks = 0